import { render, staticRenderFns } from "./UserMescanHeartStatistics.vue?vue&type=template&id=3bc67cce&scoped=true"
import script from "./UserMescanHeartStatistics.vue?vue&type=script&lang=js"
export * from "./UserMescanHeartStatistics.vue?vue&type=script&lang=js"
import style0 from "./UserMescanHeartStatistics.vue?vue&type=style&index=0&id=3bc67cce&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3bc67cce",
  null
  
)

export default component.exports